import { useState } from 'react';
import React from "react";
import {Yup} from "../components";
import RoleSelect from "./RoleSelect";
import CompanySelect from "./CompanySelect";
import UserForm from "./UserForm";
import {useGetRolesQuery} from "../../api/roleApiSlice";

function AdminUserForm(props) {

  const [companyType, setCompanyType] = useState(null)
  const {data: roles = [], isSuccess} = useGetRolesQuery()

  const formInitProps = {
    validationSchema: {
      company: Yup.object().shape({
        id: Yup.string().nullable(),
        type: Yup.string().nullable(),
      }),
    },
    initialValues: {
      company: (obj) => obj ? {id: obj.company?.id, type: obj.company?.type} : {}
    }
  }

  return (
    <UserForm formInitProps={formInitProps} {...props}>
      <CompanySelect company onCompanyTypeChange={setCompanyType}/>
      <RoleSelect role isMulti={!companyType} companyType={companyType} canChangeCompanyType={true} roles={roles}/>
    </UserForm>
  )
}

export default AdminUserForm
